// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"3afa9971","660":"16a612fe"}[chunkId] + ".chunk.css";
};